"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPose = _interopRequireWildcard(require("react-pose"));
var _Weeks = _interopRequireDefault(require("./components/Weeks"));
var _WeeklyLineups = _interopRequireDefault(require("./templates/WeeklyLineups"));
var _helpers = require("../../content/helpers/helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var templates = {
  WeeklyLineups: _WeeklyLineups["default"]
};
var ItemPosed = _reactPose["default"].div({
  enter: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0
  }
});
var WeeklyTabs = exports["default"] = /*#__PURE__*/function (_Component) {
  function WeeklyTabs() {
    var _this;
    (0, _classCallCheck2["default"])(this, WeeklyTabs);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WeeklyTabs, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      activeWeek: 0
    });
    (0, _defineProperty2["default"])(_this, "changeWeek", function (updatedWeek) {
      var activeWeek = _this.state.activeWeek;
      activeWeek = updatedWeek;
      _this.setState({
        activeWeek: activeWeek
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(WeeklyTabs, _Component);
  return (0, _createClass2["default"])(WeeklyTabs, [{
    key: "render",
    value: function render() {
      var activeWeek = this.state.activeWeek;
      var _this$props = this.props,
        weeks = _this$props.weeks,
        template = _this$props.template,
        children = _this$props.children;
      var TemplateSelected = templates[template];
      if (weeks.length) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "d8-c-weekly-tabs"
        }, /*#__PURE__*/_react["default"].createElement(_Weeks["default"], {
          weeks: weeks,
          activeWeek: activeWeek,
          changeWeek: this.changeWeek
        }), /*#__PURE__*/_react["default"].createElement(_reactPose.PoseGroup, null, /*#__PURE__*/_react["default"].createElement(ItemPosed, {
          key: (0, _helpers.generateKey)()
        }, !children && /*#__PURE__*/_react["default"].createElement("div", {
          className: "margin-top-md"
        }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, (0, _extends2["default"])({}, this.props, {
          week: weeks[activeWeek],
          activeWeek: activeWeek
        }))), children && /*#__PURE__*/_react["default"].createElement("div", {
          className: "margin-top-md"
        }, children({
          activeWeek: activeWeek,
          changeWeek: this.changeWeek
        })))));
      }
      return null;
    }
  }]);
}(_react.Component);
WeeklyTabs.propTypes = {
  children: _propTypes["default"].any,
  weeks: _propTypes["default"].array,
  template: _propTypes["default"].string
};
WeeklyTabs.defaultProps = {
  weeks: {},
  template: 'WeeklyLineups'
};